export function getPolygonCentroidFromUrl(
    url: string
): { lat: number, lng: number } | null {
  try {
    const u = new URL(url);

    const latRaw = u.searchParams.get("centroid_lat");
    const lngRaw = u.searchParams.get("centroid_long");

    if (!latRaw || !lngRaw) {
      return null;
    }

    const lat = parseFloat(latRaw);
    const lng = parseFloat(lngRaw);

    if (isNaN(lat) || isNaN(lng)) {
      return null;
    }

    return { lat, lng };
  } catch (e) {
    return null;
  }
}